import type { XMLFeed } from '@ps/web-martech-cms-types';
import { chunk } from 'lodash';
import React, { useEffect, useState } from 'react';

import styles from './CMSXMLFeed.scss';

const CMSXMLFeed: React.FC<XMLFeed> = ({ asset, tag }) => {
  const [feed, setFeed] = useState([] as Element[][]);
  const [lastUpdate, setLastUpdate] = useState('');

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;

    const fetchXML = async () => {
      if (!asset) {
        return;
      }

      const res = await (await fetch(asset.url, { signal })).text();
      const xml = new DOMParser().parseFromString(res, 'text/xml');

      const feedList = tag ? xml.getElementsByTagName(tag) : xml.documentElement.children;
      const result: Element[][] = chunk(feedList, 3);

      setFeed(result);

      const time: HTMLCollectionOf<Element> = xml.getElementsByTagName('lastUpdated');
      setLastUpdate(time?.[0]?.childNodes[0].nodeValue || '');
    };

    fetchXML();

    return () => abortController.abort();
  }, [asset, tag]);

  return (
    <div>
      <table className={styles.feedTable}>
        <tbody>
          {feed.map((item, i) => (
            <tr key={i}>
              {item.map((ele, index) => (
                <td key={index}>{ele.childNodes[0].nodeValue || ''}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <p>{lastUpdate}</p>
    </div>
  );
};

export default CMSXMLFeed;
